// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__XftbQ","rotating":"Loader_rotating__zTz-x"};